import { render, staticRenderFns } from "./Deduction.vue?vue&type=template&id=634cf6ea&scoped=true&"
import script from "./Deduction.vue?vue&type=script&lang=js&"
export * from "./Deduction.vue?vue&type=script&lang=js&"
import style0 from "./Deduction.vue?vue&type=style&index=0&id=634cf6ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634cf6ea",
  null
  
)

export default component.exports